<template>
  <div class="tips">
    <div class="tips__content">
      <div class="tips__background"></div>

      <div v-if="$slots.heading" class="tip-heading">
        <slot name="heading" />
      </div>

      <div v-if="$slots.body" class="tip-body">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:color';
@use 'core/colors';
@use 'core/layout/grid-vars';
@use 'core/layout/zindex';
@use 'core/typography/fonts';
@use 'core/typography/type';
@use 'vendor/bootstrap/scss/mixins/breakpoints';

.tips {
  background: linear-gradient(
    270deg,
    colors.color(background) 16.5%,
    color.adjust(colors.color(background), $alpha: -1) 100%
  );
  background-image: url(../../assets/images/huginn_talking.png);
  background-size: contain;
  background-position: left bottom;
  background-repeat: no-repeat;
  position: relative;
  padding: 4rem 2rem;
  display: flex;
  justify-content: center;
  background-color: colors.color(background);
  overflow: hidden;

  @include breakpoints.media-breakpoint-up(md) {
    padding: 6rem;
  }

  &__background {
    position: absolute;
    top: 0;
  }

  &__content {
    @include zindex.z-index(above-arbitrary);

    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    @include breakpoints.media-breakpoint-up(xl) {
      margin-left: 25%;
      margin-right: auto;
      max-width: 768px;
    }

    @include breakpoints.media-breakpoint-up(xxl) {
      margin-left: auto;
    }
  }

  .tip-heading {
    @include type.text--mono;
    @include fonts.font-size(15);

    font-weight: 500;
    margin-bottom: grid-vars.space(1.5);
    color: colors.color(grey, secondary);
  }

  .tip-body {
    @include fonts.font-size(16);

    font-family: fonts.$font-family-work;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -0.02rem;
    color: colors.color(grey, secondary);
  }
}
</style>
